import DOMPurify from "dompurify";
import {Modal} from "react-bootstrap";

import Button from "@/components/button/Button.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {shortDateTimeUser} from "@/lib/format.tsx";

import style from "@/pages/checks/analysis/overview/CloudStatusOutput.module.scss";

export interface CloudStatus {
  feed_url: string;
  group: string;
  history: string;
  current_incident: string;
  is_up: boolean;
  logo_src: string;
  name: string;
  sub_status: string;
  sub_title: string;
  title: string;
  display_title?: string;
  display_sub_title?: string;
}

export interface Incident {
  guidslink?: boolean;
  id: string;
  link: string;
  links?: [];
  published?: string;
  published_parsed?: object;
  updated?: string;
  parsed_date_str: string;
  parsed_date: number;
  summary: string;
  summary_detail?: object;
  title: string;
  title_detail?: object;
  incident_status: string;
}

interface CloudStatusIncidentDetailsDrawerProps {
  onCancel: () => void;
  selectedIncident: Incident | undefined;
  cloudStatus: CloudStatus;
}

export const CloudStatusIncidentDetailsDrawer = ({
  onCancel,
  selectedIncident,
  cloudStatus,
}: CloudStatusIncidentDetailsDrawerProps) => {
  const {user} = useCurrentUserContext();

  return (
    <>
      {selectedIncident && (
        <Modal show onHide={onCancel} size="lg" centered>
          <Modal.Header closeButton>
            <Modal.Title>Incident Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="pulseTextH2Bold">{selectedIncident.title}</div>
            <div className="row mt-3 mb-5">
              <div className="col">
                <div className="pulseTextBody">Vendor Name:</div>
                <div className="pulseTextBodyBold">{cloudStatus.group}</div>
              </div>
              <div className="col">
                <div className="pulseTextBody">Vendor Service:</div>
                <div className="pulseTextBodyBold">
                  {(cloudStatus.display_title || cloudStatus.title) +
                    " " +
                    (cloudStatus.display_sub_title || cloudStatus.sub_title)}
                </div>
              </div>
              <div className="col">
                <div className="pulseTextBody">Last Updated:</div>
                <div className="pulseTextBodyBold">{shortDateTimeUser(selectedIncident.parsed_date_str, user!)}</div>
              </div>
            </div>
            <div
              className={style.cloudStatusOutput}
              dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(selectedIncident.summary)}}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={onCancel} variant="secondary" data-bs-dismiss="modal">
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};
